import { createSlice } from '@reduxjs/toolkit';
import { loadBusinessConfiguration } from './thunks/loadBusinessConfiguration.thunk';

const businessConfigurationsSlice = createSlice({
  name: 'businessConfigurations',
  initialState: {
    businessConfigurations: {},
    loadingBusinessConfiguration: false,
    error: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadBusinessConfiguration.pending, (state) => {
        state.loadingBusinessConfiguration = true;
      })
      .addCase(loadBusinessConfiguration.fulfilled, (state, action) => {
        const { businessId, businessConfiguration } = action.payload || {};

        if (businessId) {
          state.businessConfigurations[businessId] = businessConfiguration || null;
        }

        state.loadingBusinessConfiguration = false;
      })
      .addCase(loadBusinessConfiguration.rejected, (state, action) => {
        state.loadingBusinessConfiguration = false;
        state.error = action.error;
      });
  },
});

export default businessConfigurationsSlice.reducer;
